module.exports = __webpack_public_path__ + "static/media/abhjit.fc79f889.jpg";